import { DataRow } from 'app/types/components/data-rendering'
import { useDatabase } from '../composables/database'
import { TasksRows } from '../types/database'

type TaskModelReturn = {
  getTasks: () => Promise<TasksRows | void>
  writeTasks: (data: any) => Promise<void>
  clearTasks: () => Promise<void>
  saveByIndex: (index: number, data: DataRow) => Promise<void>
}
export const TaskModel = (): TaskModelReturn => {
  const { query, run } = useDatabase()
  const queryTask = async (sql: string) => {
    return await query(sql)
      .then((tasks: TasksRows | void | null) => {
        if (tasks && tasks.length) {
          return JSON.parse(tasks[0]['task_data'])
        } else {
          return []
        }
      })
      .catch((error) => console.log(error))
  }

  const getTasks = async () => {
    const sql = `
        SELECT * FROM task_data WHERE id = 0;
        `
    return await queryTask(sql).catch((error) => console.log(error))
  }

  const writeTasks = async (data: any) => {
    const sql = `
      INSERT OR REPLACE INTO task_data ('id', 'task_data')
      VALUES (0, ?);`

    const values = [JSON.stringify(data)]
    await run(sql, values)
  }

  const saveByIndex = async (index: number, data: DataRow) => {
    const sql = `
      UPDATE task_data
      SET 'task_data' = json_replace(task_data, '$[${index}]', json(?))
      WHERE id = 0
    `
    const values = [JSON.stringify(data)]
    await run(sql, values)
  }

  const clearTasks = async () => {
    const sql = `
      DELETE FROM task_data;
    `
    await run(sql, []).catch((error) => console.log(error))
  }

  return {
    saveByIndex,
    getTasks,
    writeTasks,
    clearTasks,
  }
}
